import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { userActions } from '../redux/actions/user.actions';
import { connect } from 'react-redux';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Scrollbar } from 'swiper';

import '../assets/styles/pages/_news-inner.scss';
import { startLoader } from '../components/common/Loader';
import { useDate as getDate } from '../hooks';

import PageNotFound from './notFound';
import { SEO } from '../utils';

SwiperCore.use([Scrollbar]);

const NewsInner = ({ match, getNews, ...props }) => {
  const swiperParams = {
    speed: 100,
    spaceBetween: '5%',
    slidesPerView: 1.3,
    freeMode: true,
    scrollbar: {
      el: '.myCustomScrollbar',
      draggable: true,
      snapOnRelease: true,
      dragSize: 40,
    },
    breakpoints: {
      768: {
        slidesPerView: 2.8,
      },
    },
    onSlideChange,
  };

  function onSlideChange (e) {
    const endpointStyle = document.querySelector('.scrollbarEndPoint').style;
    endpointStyle.opacity = e.realIndex === e.slides.length - 1 ? 0 : 1;
  }

  const { url } = match.params;
  const [news, setNews] = useState({});
  const [date, setDate] = useState({});

  useEffect(() => {
    startLoader();
  }, [match.params.url]);

  useEffect(() => {
    getNews(url).then((response) => {
      const date = getDate(response.res[0].date);
      setDate(date);
      setNews(...response.res);
    });
  }, [match.params.url, url, getNews]);

  const { poster, title, about, photos, read_more_news: readMoreNews } = news;

  return props.news?.error ? (
    <PageNotFound loader={false} />
  ) : (
    <>
      <SEO
        title={
          (news.title && news.title.replace(/(<([^>]+)>)/gi, '')) ||
          (props.news?.items?.[0] &&
            props.news?.items?.[0].title.replace(/(<([^>]+)>)/gi, ''))
        }
        description={
          (news.about &&
            news.about !== null &&
            news.about.replace(/(<([^>]+)>)/gi, '')) ||
          (props.news?.items?.[0] &&
            props.news?.items?.[0].about !== null &&
            props.news?.items?.[0].about.replace(/(<([^>]+)>)/gi, ''))
        }
        img={
          (news.poster && news.poster) ||
          (props.news?.items?.[0] && props.news?.items?.[0].poster)
        }
      />

      <div className='news__inner'>
        <Link to='/' className='banner-logo'>
          <img src='/media/images/InClassicaColorLogo.png' alt='logo' />
        </Link>
        <div className='news'>
          <div className='news__main'>
            <div
              className='poster'
              style={{ backgroundImage: `url('${poster}')` }}
            />
            <div className='date'>
              {date.day} {date.month} {date.year}
            </div>

            <h1 className='title' dangerouslySetInnerHTML={{ __html: title }} />

            {about && about !== null && (
              <p
                className='about'
                dangerouslySetInnerHTML={{ __html: about }}
              />
            )}

            {photos && photos.length ? (
              <div className='news__photos'>
                <Swiper {...swiperParams} className='news__photos__slider'>
                  {photos.map((img, i) => (
                    <SwiperSlide
                      key={i}
                      className='photo'
                      style={{ backgroundImage: `url(${img.src})` }}
                    />
                  ))}
                </Swiper>
                <div className='scrollbarContainer'>
                  <div className='myCustomScrollbar'>
                    <div className='scrollbarEndPoint' />
                    <div className='scrollbarStartPoint' />
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>

          {readMoreNews && readMoreNews.length ? (
            <div className='news__read__more'>
              <div className='news__read__more__listing'>
                <h2 className='section__title'>READ MORE</h2>
                {readMoreNews.map((n, i) => {
                  const d = getDate(n.date);
                  return (
                    <Link
                      to={`/news/${n.url}`}
                      key={n.id}
                      className='news__read__more__listing__card'
                    >
                      <div
                        className='poster'
                        style={{ backgroundImage: `url('${n.poster}')` }}
                      />
                      <p className='date'>
                        {d.day} {d.month} {d.year}
                      </p>
                      <h2 className='title'>{n.title}</h2>
                    </Link>
                  );
                })}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );
};

const mapState = (state) => {
  return { news: state.getNews };
};

NewsInner.propTypes = {
  match: PropTypes.object,
  getNews: PropTypes.func,
  news: PropTypes.object,
};

const actionCreators = {
  getNews: userActions.getNews,
};

NewsInner.serverFetch = (url) => actionCreators.getNews(url);

export default connect(mapState, actionCreators)(NewsInner);
